import { IFounder } from '@/interfaces/founders'
import { mapImageFields } from '@/adapters/common'
import { defaultLocaleFull } from '@/shared/utils/directus'

export function mapFounderFields(item: Directus.Founder, locale: string = defaultLocaleFull): IFounder | null {
  const { image, image_en, translations } = item

  const imageMapped = mapImageFields(image)
  const imageEnMapped = mapImageFields(image_en)

  if (!translations?.[0].name || !(imageMapped || imageEnMapped)) return null

  return {
    id: item.id,
    image: locale === defaultLocaleFull ? imageMapped : imageEnMapped || imageMapped,
    ...translations[0],
  }
}
